import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'

@Component
export default class CommerceBanner extends Vue {
  @Prop({ default: () => [] }) banners;

  currentIndex = 0;

  get getCurrentImage() {
    let bannerUrl = "/assets/images/todoscomemos/todoscomemos_banner.jpg";
    if (
      this.banners[this.currentIndex] &&
      this.banners[this.currentIndex].image &&
      this.banners[this.currentIndex].image.url
    ) {
      bannerUrl = this.banners[this.currentIndex].image.url;
    }
    return bannerUrl;
  }

  onNextBanner() {
    if(this.currentIndex === this.banners.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
  }

  onPreviousBanner() {
    if(this.currentIndex === 0) {
      this.currentIndex = this.banners.length - 1;
    } else {
      this.currentIndex--;
    }
  }

  onClickBanner() {
    if(this.banners && this.banners.length && this.banners[this.currentIndex]) {
      const banner = this.banners[this.currentIndex];
      if(banner && banner.url && banner.url.length) {
        let url: string = banner.url;
        if(!url.includes('http://') && !url.includes('https://')) {
          url = "https://" + banner.url;
        }
        location.href = url;
      }
    }
  }
}
